import { AuthAdminCtrlManagementCtrlApi } from "./generated/api";
import type { ValidateUserDto } from "./generated/api";
import { apiCall, axiosInstance, config, getConfig, serverUrl } from "./Utils";
import type { ApiResult, PromiseUser } from "../types/api";

const authAdminApi = new AuthAdminCtrlManagementCtrlApi(config, serverUrl, axiosInstance);

/**
 * Récupère la liste complète de tous les utilisateurs (accès admin).
 * Endpoint : GET /api/auth/admin/
 */
async function listAllUsers(): Promise<ApiResult<PromiseUser[]>> {
    return apiCall(authAdminApi.apiAuthAdminGet(getConfig()));
}

/**
 * Crée un nouvel utilisateur (accès admin).
 * Endpoint : POST /api/auth/admin/create
 */
async function createUser(user: PromiseUser): Promise<ApiResult<void>> {
    return apiCall(authAdminApi.apiAuthAdminCreatePost(user, getConfig()));
}

/**
 * Supprime un utilisateur par son identifiant (accès admin).
 * Endpoint : DELETE /api/auth/admin/?id=...
 */
async function deleteUser(id: string): Promise<ApiResult<void>> {
    return apiCall(authAdminApi.apiAuthAdminDelete(id, getConfig()));
}

/**
 * Met à jour un utilisateur existant (accès admin).
 * Endpoint : PUT /api/auth/admin/update
 */
async function updateUser(user: PromiseUser): Promise<ApiResult<void>> {
    return apiCall(authAdminApi.apiAuthAdminUpdatePut(user, getConfig()));
}

/**
 * Récupère les utilisateurs en attente de validation (accès admin).
 * Endpoint : GET /api/auth/admin/pending
 */
async function getPendingUsers(): Promise<ApiResult<PromiseUser[]>> {
    return apiCall(authAdminApi.apiAuthAdminPendingGet(getConfig()));
}

/**
 * Valide un utilisateur en attente (accès admin).
 * Endpoint : POST /api/auth/admin/validate
 */
async function validateUser(login: string, password: string): Promise<ApiResult<void>> {
    const dto: ValidateUserDto = { login, password };
    return apiCall(authAdminApi.apiAuthAdminValidatePost(dto, getConfig()));
}

/**
 * Récupère la liste des groupes distincts (accès admin).
 * Endpoint : GET /api/auth/admin/groups
 */
async function listDistinctGroups(): Promise<ApiResult<string[]>> {
    return apiCall(authAdminApi.apiAuthAdminGroupsGet(getConfig()));
}

/**
 * Récupère la liste des institutions distinctes (accès admin).
 * Endpoint : GET /api/auth/admin/institutions
 */
async function listDistinctInstitutions(): Promise<ApiResult<string[]>> {
    return apiCall(authAdminApi.apiAuthAdminInstitutionsGet(getConfig()));
}

const ApiAdminCtrl = {
    listAllUsers,
    createUser,
    deleteUser,
    updateUser,
    getPendingUsers,
    validateUser,
    listDistinctGroups,
    listDistinctInstitutions,
};

export default ApiAdminCtrl;

